import type { FileUploadDone } from '../ImageDragger';

export const generateUploadFile = <T extends { filename?: string; id: string; url: string }>({
  response,
}: {
  response: T;
}): [FileUploadDone<T>] => [
  {
    name: response.filename ?? 'GENERATED_FILENAME',
    response,
    status: 'done',
    uid: response.id,
    url: response.url,
  },
];
